import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import {style} from "variables/Variables.jsx";
import jwt_decode from "jwt-decode";
import {CSVLink} from "react-csv";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Stock extends Component{
  constructor(props){
    super(props);
    this.state = {
      stock_response: [],
      loading:true,
        ExcelHeaders : [
            { label: "S.No.", key: "SNo" },
            { label: "Facility Name", key: "FacilityName" },
            { label: "Stock Id", key: "StockId" },
            { label: "ISKU", key: "ISKU" },
            { label: "ISKU Description", key: "ISKUDescription" },
            { label: "Current Stock", key: "CurrentStock" },
            { label: "Ordered Quantity", key: "OrderedQuantity" },
            { label: "Current Demand", key: "CurrentDemand" },
            { label: "Lost Count", key: "LostCount" }
        ],
        ExcelData : []

    }
  }
  componentDidMount() {
    this.refreshStocks();
  }
  refreshStocks(){
    const token = localStorage.usertoken;
    let warehouse_id = '';
    if(token != null) {
        const decoded = jwt_decode(token);
        warehouse_id = decoded.warehouse_id
    }
    if ($.fn.DataTable.isDataTable('#stocksTable')) {
        $('#stocksTable').DataTable().destroy();
    }
    axios.get(config.get('API_URL')+'/inventory/stocks?user_id='+warehouse_id,{
      headers: {
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
        console.log('got response...');
        console.log(response);

var temExcelData=[];
        response.data.map((value, index)=>{
            var tempData={
                SNo:index+1,
                FacilityName:value.Facility_Name__r.Name,
                StockId:value.Name,
                ISKU: value.SKU__r === undefined ? '': value.SKU__r.Name,
                ISKUDescription:value.SKU_Description__c,
                CurrentStock:value.Current_Stock__c,
                OrderedQuantity:value.Ordered_Quantity__c,
                CurrentDemand:value.Demand__c,
                LostCount:value.Lost_Count__c
            }
            temExcelData.push(tempData);
        });

        this.setState({
            stock_response: response.data,
            ExcelData:temExcelData
        })
        $('#stocksTable').DataTable({
            "oLanguage": {
                "sEmptyTable": "There are no stocks available"
            }
        });
        this.setState({
            loading: false
        })
    }).catch(error => {
        console.log('error response...');
        console.log(error.response);
    });
  }
  render(){
    let stocks_data = this.state.stock_response.map((value, index) => {
      return (
          <tr key={index + 1}>
              <td>{index + 1}</td>
              <td>{value.Facility_Name__r.Name}</td>
              <td>{value.Name}</td>
              <td>{ value.SKU__r === undefined ? '': value.SKU__r.Name }</td>
              <td>{value.SKU_Description__c}</td>
              <td>{value.Current_Stock__c}</td>
              <td>{value.Ordered_Quantity__c}</td>
              <td>{value.Demand__c}</td>
              <td>{value.Lost_Count__c}</td>
          </tr>
      )
    });
    return(
      <div className="">
          <div className="container-fluid">
              <div className="row">
                  <div className="">
                    <div className="">
                        <p className="category"></p>
                    </div>
                  </div>

                      <div className='sweet-loading'>
                          <BeatLoader
                              css={override}
                              sizeUnit={"px"}
                              size={20}
                              color={'#123abc'}
                              loading={this.state.loading}
                          />
                      </div>
                      <div className="content-tdetails-table table-full-width table-responsive">

                          <div className="p-5">
                              <CSVLink data={this.state.ExcelData} headers={this.state.ExcelHeaders} >
                                  <span className="btn btn-primary pull-right "> Export To Excel</span>
                              </CSVLink>
                              <br />
                          </div>

                          <table className="table table-striped table-hover" id="stocksTable">
                              <thead>
                              <tr>
                                  <th>S.No.</th>
                                  <th>Facility name</th>
                                  <th>Stock id</th>
                                  <th>ISKU</th>
                                  <th>ISKU description</th>
                                  <th>Current stock</th>
                                  <th>Ordered quantity</th>
                                  <th>Current demand</th>
                                  <th>Lost count</th>
                              </tr>
                              </thead>
                              <tbody>
                                  {stocks_data}
                              </tbody>
                          </table>
                      </div>

                  <div className="footer">
                      <div className="stats"><i></i></div>
                  </div>
              </div>
          </div>
      </div>
    );
  }
}

export default Stock;
